import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { CarModelService } from 'src/app/car-model/car-model.service';
import { CarModelTypeCreateComponent } from 'src/app/car-model-type/car-model-type-create/car-model-type-create.component';
import { CarModelTypeService } from '../car-model-type.service';
import { AppState } from 'src/app/redux/app.state';
import { setLoading } from 'src/app/redux/actions/user.actions';
import { CarModel, CarModelType } from 'src/typings';

@Component({
  selector: 'app-car-model-type-list',
  templateUrl: './car-model-type-list.component.html',
  styleUrls: ['./car-model-type-list.component.scss']
})
export class CarModelTypeListComponent {
  carModel: CarModel | undefined;

  carModelTypes: CarModelType[] = [];

  filteredCarModelTypes = new MatTableDataSource<CarModelType>();

  displayedColumns: string[] = [
    'id',
    'description',
    'capacity',
    'horsePower',
    'kW',
    'fuelType',
    'date_from',
    'date_to'
  ];

  constructor(
    private carModelTypeService: CarModelTypeService,
    private router: Router,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private carModelService: CarModelService,
    private store: Store<AppState>
  ) {
    this.activatedRoute.params.subscribe((params) => {
      this.carModelService.search({ id: params.id }).subscribe((result) => {
        this.carModel = result.data[0];
        this.loadTypes();
      });
    });
  }

  set loading(value: boolean) {
    this.store.dispatch(setLoading({ payload: value }));
  }

  loadTypes() {
    if (!this.carModel) return;
    this.loading = true;
    this.carModelTypeService
      .search({
        carModelId: this.carModel.id
      })
      .subscribe((result) => {
        this.loading = false;
        this.carModelTypes = result.data;
        this.filteredCarModelTypes.data = result.data;
      });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filteredCarModelTypes.data = this.carModelTypes.filter((row) => {
      return row.description.toUpperCase().includes(filterValue.toUpperCase());
    });
  }

  getEngineDescription(type: CarModelType) {
    return type.engines.map((engine) => engine.description).join(', ');
  }

  add() {
    if (!this.carModel) return;
    const dialogRef = this.dialog.open(CarModelTypeCreateComponent);
    dialogRef.componentInstance.dialogRef = dialogRef;
    dialogRef.componentInstance.carModel = this.carModel;
    dialogRef.componentInstance.newCarModifictionEvent.subscribe(() => {
      this.loadTypes();
    });
  }

  getEndDate(date: Date | undefined) {
    if (date) return date.toLocaleDateString();
    return new Date().toLocaleDateString();
  }
}
